// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line[data-v-61a631ba] {\n  width: 30px;\n  height: 3px;\n  color: #333; /* old IE */\n  background-color: #333; /* Modern Browsers */\n}", ""]);
// Exports
module.exports = exports;
